import { createRequestActionTypes } from "../../../shared/utility";

export const TerminalActions = {
    fetchTerminalDetails: createRequestActionTypes('FETCH_TERMINAL_DETAILS'),
    createTerminalDetails: createRequestActionTypes('CREATE_NEW_TERMINAL'),
    deleteTerminal: createRequestActionTypes('DELETE_TERMINAL'),
    fetchHardwareTypes: createRequestActionTypes('FETCH_HARDWARE_TYPES'),
}